import React from 'react';
import Table from '../../../core/form/Table';
import PropTypes from 'prop-types';
import moment from 'moment';
import { BRAZIL, dollarCurrencyFormatter, realCurrencyFormatter } from '../../../core/consts';
import { startCase, upperFirst } from 'lodash';

function ContractOpenBillsList({ bills }) {
  return (
    <Table
      columns={[
        {
          label: 'Bill ID',
          path: 'billId',
        },
        {
          label: 'Due Date',
          path: 'dueDate',
          render: (value) => moment(value).utc().format('DD/MM/YYYY'),
        },
        {
          label: 'Total Price',
          path: 'total',
          render: (value, row) =>
            BRAZIL.includes(row.contract.country)
              ? realCurrencyFormatter.format(value)
              : dollarCurrencyFormatter.format(value),
        },
        {
          label: 'Status',
          path: 'status',
          render: (value) => upperFirst(startCase(value.toLowerCase())),
        },
      ]}
      rows={bills}
    />
  );
}

ContractOpenBillsList.propTypes = {
  bills: PropTypes.arrayOf(
    PropTypes.shape({
      billId: PropTypes.string.isRequired,
      dueDate: PropTypes.string.isRequired,
      total: PropTypes.number.isRequired,
      status: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ContractOpenBillsList;
